import { App } from '@capacitor/app';
import { StatusBar, Style } from '@capacitor/status-bar';
import { Keyboard } from '@capacitor/keyboard';
import { SplashScreen } from '@capacitor/splash-screen';
import { isNative, isIOS } from './platform';

/**
 * Initialize native platform features.
 * Call once from your app entry point (index.tsx or App.tsx).
 * Safe to call on web — guards with isNative checks.
 */
export const initNative = async () => {
  if (!isNative) return;

  // Dark status bar text on light backgrounds
  try {
    await StatusBar.setStyle({ style: Style.Dark });
    if (!isIOS) {
      await StatusBar.setBackgroundColor({ color: '#000000' });
    }
  } catch {
    // Status bar plugin may not be available in all contexts
  }

  // Hide splash screen after app renders
  try {
    await SplashScreen.hide();
  } catch {
    // Splash screen may already be hidden
  }

  // Handle keyboard behavior on iOS
  if (isIOS) {
    try {
      Keyboard.addListener('keyboardWillShow', () => {
        document.body.classList.add('keyboard-open');
      });
      Keyboard.addListener('keyboardWillHide', () => {
        document.body.classList.remove('keyboard-open');
      });
    } catch {
      // Keyboard plugin optional
    }
  }

  // Handle Android back button
  App.addListener('backButton', ({ canGoBack }) => {
    if (canGoBack) {
      window.history.back();
    } else {
      App.exitApp();
    }
  });

  // Handle deep links
  App.addListener('appUrlOpen', ({ url }) => {
    const path = new URL(url).pathname;
    if (path) {
      window.location.href = path;
    }
  });
};
